import React from "react";
import { Menu } from "semantic-ui-react";
import { useIntl } from "react-intl";

const DEFAULT_PROPS = {
  leftItem: null,
  middleItem: null,
  rightItem: null,
  menuBarClassName: "",
  hideLeftItem: false,
  hideRightItem: false,
}
const MobileMenuBar = propsParam  => {

  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined))
  }
  
  return (
    <Menu className={`menu-bar ${props.menuBarClassName}`} secondary borderless size="large">
      {!props.hideLeftItem && <Menu.Item>{props.leftItem}</Menu.Item>}
      <Menu.Item className="chat-channel-name">{props.middleItem}</Menu.Item>
      {!props.hideRightItem && <Menu.Item position={"right"} className="right-item">
        {props.rightItem}
      </Menu.Item>}
    </Menu>
  );
};


export default MobileMenuBar;
